import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=ab91ee08&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=ab91ee08&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab91ee08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab91ee08')) {
      api.createRecord('ab91ee08', component.options)
    } else {
      api.reload('ab91ee08', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=ab91ee08&scoped=true", function () {
      api.rerender('ab91ee08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/premium/detail.vue"
export default component.exports